//description: components interface that requires to have
//             - isUpdateRealTime property
//             - update() method to update the component with new data
//			   - onDataStreamAdded() method to be notified with when data stream is added for the containing widget
//			   - isNotInterestedInAnyDataFields() return true of component is not interested in any datafields
//			   - resize() is repeatedly called when widget resizes

import DataStore from "../../../../core/stores/dataStore.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import InternalEventBus from "../../../../core/utils/internalEventBus.js";

module.exports = function (componentId, widgetId, legends, togglePreloader) {
  // //////// private members
  var _this = this;
  var widgetId = widgetId;
  var legends = legends;
  var updateCallback = null;
  var eventTokens = [];
  var serverSideFunctionData;

  // //////// public members
  this.id = componentId;

  function init() {
    let token = InternalEventBus.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, handleLegendUpdate);
    eventTokens.push(token);
    togglePreloader(true);
  }

  function handleLegendUpdate(payload) {
    if (payload.widgetId !== widgetId) return;
    _this.update();
  }

  this.loadHistoricData = function (historicData) {
    togglePreloader(false);
    serverSideFunctionData = historicData;
    if (updateCallback != null) {
      var newData = [];
      for (var i = 0; i < legends.length; i++) {
        var data = {};
        data.identifier = legends[i].id;
        data.legendLabel = legends[i].parameters.legendLabel;

        var datasetsData = {};
        for (var key in legends[i].mappings) {
          var datasetId = legends[i].mappings[key].datasetId;
          datasetsData[datasetId] = historicData[datasetId][0];
          if (datasetsData[datasetId]) {
            historicData[datasetId][0].time = historicData[datasetId][0].timestamp;
          }
          DataStore.store(datasetId, historicData[datasetId][0]);
        }

        if (legends[i].hasOwnProperty("serverSideFunction")) {
          legends[i].serverSideFunction.map(ssf => {
            const requestId = ssf.requestId;
            datasetsData[requestId] = historicData[requestId][0];

          });
        }

        for (var key in legends[i].functions) {
          var yValue = 0;
          try {
            yValue = legends[i].functions[key](datasetsData);
          } catch (e) {
          }

          data[key] = yValue;
        }
        newData.push(data);
      }

      updateCallback(newData, _this.id);
    }
  };

  this.update = function () {
    // pie chart
    if (updateCallback != null) {
      var newData = [];
      for (var i = 0; i < legends.length; i++) {
        var data = {};
        data.identifier = legends[i].id;
        data.legendLabel = legends[i].parameters.legendLabel;

        var datasetsData = {};
        for (var key in legends[i].mappings) {
          var datasetId = legends[i].mappings[key].datasetId;
          datasetsData[datasetId] = DataStore.get(datasetId);
        }

        if (legends[i].hasOwnProperty("serverSideFunction")) {
          legends[i].serverSideFunction.forEach(ssf => {
            const requestId = ssf.requestId;
            datasetsData[requestId] = serverSideFunctionData[requestId][0];
          });
        }

        for (var key in legends[i].functions) {
          var yValue = 0;
          try {
            yValue = legends[i].functions[key](datasetsData);
          } catch (e) {
          }

          data[key] = yValue;
        }

        //if (isNaN(data.y)) debugger;

        newData.push(data);
      }

      updateCallback(newData, _this.id);
    }
  };

  this.isNotInterestedInAnyDataFields = function () {
    for (var i in legends) {
      return false;
    }

    return true;
  };

  this.addUpdateListener = function (callback) {
    updateCallback = callback;
  };

  this.resize = function () {

  };

  this.onDataFieldsModified = function (allDataFields) {

  };

  this.getLegends = function () {
    return legends;
  };

  // TODO: history size is how many data points does the chart display prior to start
  // updating itself on real-time updates. This value is hard-coded for now.
  this.getHistorySize = function () {
    return 1;
  };

  this.destroy = function () {
    eventTokens.map(token => {
      InternalEventBus.unsubscribe(token);
    });
  };

  this.getLegends = function () {
    return legends;
  };

  init();
};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/pie-chart/controller.js